import React, { useEffect, useState } from "react";
import { Line } from "react-chartjs-2";
import { BsExclamationTriangle } from "react-icons/bs";
import "chartjs-adapter-moment";
import {
  Chart as ChartJS,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { getHistoricalTicks } from "../services/api";

ChartJS.register(
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const CryptoChart = ({ id, interval, start, end }) => {
  const [chartData, setChartData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getHistoricalTicks(
          id,
          interval,
          start,
          end ?? end
        );

        const historicalData = response.data.map((tick) => ({
          x: new Date(tick.timestamp),
          y: tick.price,
        }));

        setChartData({
          labels: historicalData.map((point) => point.x),
          datasets: [
            {
              label: `${id} Price History Chart`,
              data: historicalData,
              fill: false,
              borderColor: "rgb(59 130 246)",
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              tension: 0.1,
            },
          ],
        });
      } catch (error) {
        console.error("Error fetching historical data:", error);
        setChartData(null);
      }
    };
    fetchData();
  }, [id, interval, start, end]);

  return (
    <>
      {chartData ? (
        <Line
          data={chartData}
          options={{
            maintainAspectRatio: true,
            responsive: true,
            scales: {
              x: {
                type: "time",
                time: {
                  unit: "year",
                },
                ticks: {
                  callback: function (label) {
                    return `${this.getLabelForValue(label)}`;
                  },
                },
                title: {
                  display: true,
                  text: "Time",
                },
              },
              y: {
                beginAtZero: true,
                title: {
                  display: true,
                  text: "Price",
                },
              },
            },
          }}
        />
      ) : (
        <div className="italic font-light">
          <BsExclamationTriangle className="text-blue-500" />
          <p>No data available</p>
        </div>
      )}
    </>
  );
};

export default CryptoChart;
